import { FCWithChildren } from '@types';
import React from 'react';
import classNames from 'classnames';

import { IInvitee, IReceivedInvite } from 'sdk-apogee';
import {
  ActionTypes,
  REMOVE_RECEIVED_INVITATION,
  JOIN_NETWORK,
  REMOVE_SENT_INVITATION,
} from '../SharedList/SharedList';

import { MdAddLink, MdClose, MdLinkOff } from 'react-icons/md';

export type InviteeVariant = 'sent' | 'received';

type InviteeProps = {
  invitee: IInvitee | IReceivedInvite;
  variant: InviteeVariant;
  // eslint-disable-next-line no-unused-vars
  dispatch: (action: ActionTypes) => void;
};

// `bg-gray-300` / `text-blue-700` are remapped for dark mode by the global rules in index.css.
const iconButtonCls =
  'flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-transparent focus:shadow-focus';

const neutralButtonCls = classNames(iconButtonCls, 'bg-gray-300');

const Invitee: FCWithChildren<InviteeProps> = ({ invitee, variant, dispatch }) => {
  const { id, accountEmail } = invitee as IReceivedInvite;

  const acceptInvitation = () =>
    dispatch({ type: JOIN_NETWORK, payload: { invitation: invitee as IReceivedInvite } });

  const declineInvitation = () =>
    dispatch({
      type: REMOVE_RECEIVED_INVITATION,
      payload: { invitation: invitee as IReceivedInvite },
    });

  const removeSentInvitation = () =>
    dispatch({ type: REMOVE_SENT_INVITATION, payload: { sentInvitationId: id } });

  return (
    <div className="flex w-full items-center justify-between gap-4 border-b border-gray-300 py-4">
      <span className="min-w-0 break-all text-black">{accountEmail}</span>

      <div className="flex shrink-0 items-center gap-3">
        {variant === 'received' ? (
          <>
            <button
              type="button"
              aria-label={`Accept invitation from ${accountEmail}`}
              className={neutralButtonCls}
              onClick={acceptInvitation}
            >
              <MdAddLink className="text-xl text-blue-700" />
            </button>
            <button
              type="button"
              aria-label={`Decline invitation from ${accountEmail}`}
              className={classNames(iconButtonCls, 'bg-blue-700')}
              onClick={declineInvitation}
            >
              <MdClose className="text-lg text-white" />
            </button>
          </>
        ) : (
          <button
            type="button"
            aria-label={`Remove ${accountEmail} from your shared network`}
            className={neutralButtonCls}
            onClick={removeSentInvitation}
          >
            <MdLinkOff className="text-xl text-blue-700" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Invitee;
